"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/Form.css");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dist = require("package_ui_ihm/dist");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
* Nom : FileFormSide.js
* Description : Ce fichier contient la définition du composant FileFormSide
*               Ce composant est un champs pour venir sélectionner l'URL d'un fichier en local afin 
*               de le télécharger sur l'application
* Date de création : 27 mars 2026
*/

/* CSS et assets */

/* Bibliothèques et composants */

/* Hook */

/**
* FileFormSide : ce composant est un champs pour venir sélectionner l'URL d'une image en local afin 
*             de la télécharger sur l'application
*
* Type : composant 
*
* Parametres : 
*  - label -- texte affiché au dessus du champ pour apporter des précisions
*  - onChangeFunc -- fonction qui gère la sélection du nouveau fichier
*  - currentValue -- valeur de l'URL sélectionnée
*/function FileFormSide(_ref) {
  var error = _ref.error,
    label = _ref.label,
    onChangeFunc = _ref.onChangeFunc,
    currentValue = _ref.currentValue;
  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Render component
  return error ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: screenWidth > 1000 ? 'form-image form-side-label flex-column' : screenWidth > 650 ? 'form-image form-label-ss flex-column' : 'form-image form-label-tr flex-column',
    children: [label, " :", /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      type: "file",
      onChange: onChangeFunc,
      accept: "file/*",
      className: "form-image-input"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "form-error",
      children: "Ce champ est obligatoire !"
    })]
  }) : currentValue === null ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: screenWidth > 1000 ? 'form-image form-side-label flex-column' : screenWidth > 650 ? 'form-image form-label-ss flex-column' : 'form-image form-label-tr flex-column',
    children: [label, " :", /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      type: "file",
      onChange: onChangeFunc,
      accept: "file/*",
      className: "form-image-input"
    })]
  }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: screenWidth > 1000 ? 'form-image form-side-label flex-column' : screenWidth > 650 ? 'form-image form-label-ss flex-column' : 'form-image form-label-tr flex-column',
    children: [label, " (Fichier actuel : ", currentValue.split('/')[currentValue.split('/').length - 1], ") :", /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      type: "file",
      onChange: onChangeFunc,
      accept: "file/*",
      className: "form-image-input"
    })]
  });
}

// Les propTypes permettent de sécuriser les données en specifiant le type de donnée attendu pour une prop
FileFormSide.propTypes = {
  label: _propTypes["default"].string,
  onChangeFunc: _propTypes["default"].func
};
var _default = exports["default"] = FileFormSide;